import clsx from "clsx";
import React, { FunctionComponent, SVGProps } from "react";

export const CalculatorIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      {...props}
      className={clsx("tw-icon", className)}
      height="32"
      viewBox="0 0 32 38"
      width="38"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M2.5 1.75a.75.75 0 0 0-.75.75v33c0 .414.336.75.75.75h27a.75.75 0 0 0 .75-.75v-33a.75.75 0 0 0-.75-.75h-27ZM.25 2.5A2.25 2.25 0 0 1 2.5.25h27a2.25 2.25 0 0 1 2.25 2.25v33a2.25 2.25 0 0 1-2.25 2.25h-27A2.25 2.25 0 0 1 .25 35.5v-33Zm6 4.5A.75.75 0 0 1 7 6.25h18a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75H7a.75.75 0 0 1-.75-.75V7Zm1.5.75v7.5h16.5v-7.5H7.75Z"
        fillRule="evenodd"
      />
      <path d="M23.5 32.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM16 32.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM8.5 32.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM23.5 25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM16 25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM8.5 25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z" />
    </svg>
  );
};
